
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus, Minus, RotateCcw } from "lucide-react";

interface OutsControlProps {
  outs: number;
  onOutsChange: (outs: number) => void;
}

export function OutsControl({
  outs,
  onOutsChange,
}: OutsControlProps) {
  return (
    <div className="bg-white/5 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-lg sm:text-xl font-semibold text-white">Outs</h4>
        <button 
          onClick={() => onOutsChange(0)}
          className="p-2 bg-white/10 hover:bg-white/20 text-white rounded transition-colors"
        >
          <RotateCcw className="h-4 w-4" />
        </button>
      </div>
      <div className="flex items-center justify-between gap-4">
        <Button 
          onClick={() => onOutsChange(Math.max(0, outs - 1))}
          variant="outline"
          size="icon"
          className="border-white/20 h-10"
        >
          <Minus className="h-4 w-4" />
        </Button>
        <div className="text-2xl sm:text-3xl font-bold text-white">
          {outs}
        </div>
        <Button 
          onClick={() => onOutsChange(Math.min(3, outs + 1))}
          variant="outline"
          size="icon"
          className="border-white/20 h-10"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
